function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { Checkbox } from 'flowbite-react';
import { isString } from 'lodash';
import { usePopper } from 'react-popper';
import { Popover } from '@headlessui/react';
import { XMarkIcon, PlusCircleIcon } from '@heroicons/react/20/solid';
import { t, Translate } from "../../../I18N";
import { Pill } from "../UI";















const renderChild = (child, className) =>
isString(child) ? /*#__PURE__*/_jsx(Translate, { className: className || '' }, void 0, child) : child;

const MultiSelect = ({
  label,
  options,
  disabled,
  hasErrors,
  onChange = () => {},
  placeholder = 'No options',
  canBeEmpty = true,
  value
}) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'top-end',
    strategy: 'absolute'
  });

  const [currentValue, setCurrentValue] = useState(value);

  const optionIsSelected = (option) => currentValue.includes(option.value);

  const removeValue = (v) => {
    const newValue = currentValue.filter((_v) => _v !== v);
    setCurrentValue(newValue);
    onChange(newValue);
  };

  const selectOption = (option) => {
    const newValue = currentValue.includes(option.value) ?
    currentValue.filter((v) => v !== option.value) :
    [...currentValue, option.value];

    setCurrentValue(newValue);
    onChange(newValue);
  };

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (/*#__PURE__*/
    _jsx("div", { "data-testid": "multiselect", className: "rounded-lg shadow-sm" }, void 0, /*#__PURE__*/
    _jsx("div", {
      className: `flex items-center px-4 h-12 rounded-t-lg ${
      hasErrors ? 'bg-error-50' : 'bg-gray-50'}` }, void 0, /*#__PURE__*/


    _jsx("span", {
      className: `flex-1 font-semibold text-sm ${
      hasErrors ? 'text-pink-800' : 'text-gray-700'}` }, void 0,


    renderChild(label)
    ), /*#__PURE__*/
    _jsx(Popover, { className: "border border-gray-50" }, void 0, /*#__PURE__*/
    React.createElement(Popover.Button, {
      ref: setReferenceElement,
      className: " text-primary-700 disabled:text-primary-300",
      disabled: disabled || options.length === 0 }, /*#__PURE__*/

    _jsx("span", { className: "sr-only" }, void 0, t('System', 'Select', null, false)), /*#__PURE__*/
    _jsx(PlusCircleIcon, { className: "w-6 text-lg" })
    ), /*#__PURE__*/
    React.createElement(Popover.Panel, _extends({
      ref: setPopperElement,
      style: styles.popper
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, attributes.popper, {
      as: "div",
      className: "z-10" }), /*#__PURE__*/

    _jsx("ul", {
      className: "max-w-md p-2 mb-2 overflow-y-auto bg-white rounded-md shadow max-h-56 w-fit min-w-56",
      "data-testid": "multiselect-popover" }, void 0,

    options.map((option) => /*#__PURE__*/
    _jsx("li", { className: "flex gap-2 py-1 align-top" }, option.value, /*#__PURE__*/
    _jsx(Checkbox, {
      className: "cursor-pointer",
      id: option.value,
      checked: optionIsSelected(option),
      disabled:
      disabled ||
      optionIsSelected(option) && !canBeEmpty && currentValue.length === 1,

      onChange: () => {
        selectOption(option);
      } }
    ), /*#__PURE__*/
    _jsx("label", { className: "w-full cursor-pointer", htmlFor: option.value }, void 0,
    renderChild(option.label)
    )
    )
    )
    )
    )
    )
    ), /*#__PURE__*/

    _jsx("div", { className: "flex flex-wrap gap-2 p-4 min-h-fit" }, void 0,
    currentValue.length ?
    currentValue.map((v) => {
      const option = options.find((opt) => opt.value === v);
      const isDisabled = disabled || !canBeEmpty && value.length === 1;
      if (!option) return null;
      return (/*#__PURE__*/
        _jsx(Pill, { color: "gray", className: "flex flex-row gap-2" }, option.value, /*#__PURE__*/
        _jsx("span", { className: "text-gray-600" }, void 0, option.label), /*#__PURE__*/
        _jsx("button", {
          type: "button",
          className: `content-center justify-center text-xs font-bold ${
          isDisabled ?
          'text-gray-400 cursor-not-allowed' :
          'text-gray-500 hover:text-gray-700'}`,

          disabled: isDisabled,
          onClick: () => {
            removeValue(v);
          } }, void 0, /*#__PURE__*/

        _jsx(Translate, { className: "sr-only" }, void 0, "Remove"), /*#__PURE__*/
        _jsx(XMarkIcon, { className: "w-4" })
        )
        ));

    }) :
    renderChild(placeholder, 'text-gray-500')
    )
    ));

};


export { MultiSelect };